import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Markdown } from '@shared/components/typography/Markdown/Markdown';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const MAX_HIGHLIGHTS = 4;

interface PlanHighlightsProps {
  highlights: string[];
}

export const PlanHighlights = ({ highlights }: PlanHighlightsProps) => (
  <Stack component="ul" gap="10px">
    {highlights.slice(0, MAX_HIGHLIGHTS).map((text) => (
      <Stack key={text} component="li" direction="row" alignItems="center" gap="10px">
        <CheckCircleIcon className="PlanCard-highlightIcon" />
        <Typography variant="body.sm" component="div">
          <Markdown text={text} />
        </Typography>
      </Stack>
    ))}
  </Stack>
);
